/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import { TextField, FormControlLabel, Checkbox } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(() => ({
  resize: {
    padding: 14,
  },
  label: {
    marginTop: 9,
    fontSize: 16,
    color: "#1558a2",
    fontWeight: 700,
    marginRight: 10,
  },
  actions: {
    marginTop: 20,
    display: "flex",
    justifyContent: "center",
  },
}));

const ChangeItemQuantityV2 = (props) => {
  const { handleClose, open, state, onHandleChange, onSaveClick } = props;
  const classes = useStyles();

  return (
    <Fragment>
      <ControlledDialog
        hideClose
        open={open}
        disableBackdropClick
        handleClose={() => handleClose()}
        title={
          <Fragment>
            <Tooltip title="Back">
              <IconButton onClick={() => handleClose()}>
                <ArrowBackIcon fontSize="small" color="primary" />
              </IconButton>
            </Tooltip>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >
              {`${state.selectedOrderItemForCopies.id} - ${state.selectedOrderItemForCopies.productName}`}
            </span>
          </Fragment>
        }
        content={
          <Fragment>
            <span
              style={{
                fontSize: 14,
                fontWeight: 400,
              }}
            >
              {`Please enter number of copies of product `}{" "}
              <b>{state.selectedOrderItemForCopies.productName}</b>
            </span>
            <div>
              <div className={classes.label}>Number of Copies</div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <TextField
                  placeholder="Copies"
                  variant="outlined"
                  type="number"
                  inputProps={{ min: 0 }}
                  fullWidth
                  style={{
                    width: "50%",
                  }}
                  disabled={state.isRemoveExtraCopies == 1}
                  name="selectedQuantity"
                  error={state.quantityError}
                  value={
                    state.isRemoveExtraCopies == 1 ? 0 : state.selectedQuantity
                  }
                  onChange={(e) => onHandleChange(e)}
                  InputProps={{ classes: { input: classes.resize } }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="isRemoveExtraCopies"
                      checked={state.isRemoveExtraCopies == 1}
                      color="primary"
                      onChange={(e) =>
                        onHandleChange({
                          target: {
                            name: "isRemoveExtraCopies",
                            value: e.target.checked ? 1 : 0,
                          },
                        })
                      }
                      // style={{ marginLeft: "-7px" }}
                    />
                  }
                  style={{
                    width: "50%",
                    marginLeft: 20,
                  }}
                  label="No Need For Extra Copies"
                />
              </div>
            </div>

            <div className={classes.actions}>
              <Button
                onClick={() => onSaveClick()}
                disabled={state.onCancelItemStatusLoading}
                style={{ width: 100 }}
                variant="contained"
                color="primary"
              >
                {state.onCancelItemStatusLoading ? (
                  <CircularProgress size={30} />
                ) : (
                  "Save"
                )}
              </Button>
              <Button
                disabled={state.onCancelItemStatusLoading}
                style={{ marginLeft: 20 }}
                onClick={() => handleClose()}
                variant="contained"
              >
                Cancel
              </Button>
            </div>
          </Fragment>
        }
      />
    </Fragment>
  );
};

ChangeItemQuantityV2.propTypes = {
  handleClose: PropTypes.func,
  onSaveClick: PropTypes.func,
  onHandleChange: PropTypes.func,
  open: PropTypes.bool,
  state: PropTypes.object,
};

ChangeItemQuantityV2.defaultProps = {
  handleClose: (fn) => fn,
  onSaveClick: (fn) => fn,
  onHandleChange: (fn) => fn,
  open: false,
  state: {},
};

export default ChangeItemQuantityV2;
